<template>
  <v-layout>
    <v-col cols :sm="12" class="px-0 pt-5">
      <v-form v-model="Setting.isValid" ref="form">
        <v-card flat>
          <v-card-text>
            <v-row v-for="item in Setting.obj.opt.discoveries" :key="item.key">
              <v-col cols :sm="2" class="py-4">
                <h4 class="heading">{{ item.key }}:</h4>
              </v-col>
              <v-col cols :sm="4" class="py-0">
                <v-text-field
                  color="primary"
                  required
                  :rules="[Rules.required]"
                  v-model="item.nameEN"
                >
                  <template #label>
                    Name EN
                    <span class="red--text">
                      <strong>*</strong>
                    </span>
                  </template>
                </v-text-field>
              </v-col>
              <v-col cols :sm="4" class="py-0">
                <v-text-field
                  color="primary"
                  required
                  :rules="[Rules.required]"
                  v-model="item.nameVI"
                >
                  <template #label>
                    Name VI
                    <span class="red--text">
                      <strong>*</strong>
                    </span>
                  </template>
                </v-text-field>
              </v-col>
              <v-col cols :sm="1" class="py-0">
                <v-text-field
                  color="primary"
                  type="number"
                  :rules="[Rules.required, Rules.number]"
                  v-model="item.priority"
                  @change="_fnSort"
                >
                  <template #label>
                    Priority
                    <span class="red--text">
                      <strong>*</strong>
                    </span>
                  </template>
                </v-text-field>
              </v-col>
              <v-col cols :sm="1" class="py-3">
                <v-checkbox
                  color="primary"
                  label="Hide"
                  hide-details
                  v-model="item.isHide"
                ></v-checkbox>
              </v-col>
            </v-row>
          </v-card-text>
          <v-card-actions class="px-4">
            <v-spacer></v-spacer>
            <v-btn
              color="primary"
              :disabled="!Setting.isValid"
              @click="_fnUpdate()"
              >{{ $t(`table.update`) }}</v-btn
            >
            <v-spacer></v-spacer>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-col>
  </v-layout>
</template>

<script>
export default {
  data: () => ({
    model: "Setting",
  }),
  methods: {
    _fnSort() {
      this[this.model].obj.opt.discoveries.sort(
        (a, b) => a.priority - b.priority
      );
    },
    _fnUpdate() {
      this.fnPut({
        url: `/v1/admin/setting/${this[this.model].obj.type}`,
        model: this.model,
      });
    },
  },
};
</script>
